import React, { useEffect, useState } from 'react'
import { Link, resolvePath } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import PredefinedDateRanges from '../../../core/common/datePicker'
import Table from "../../../core/common/dataTable/index";
// import { leadsDataList } from '../../../core/data/json/leadsList'
// import CrmsModal from '../../../core/modals/crms_modal'
import { leadsDataList } from '../../../core/data/json/leadsList'
import { bookingReconciliationList } from '../../../core/data/json/bookingReconciliation'
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod'
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl'
import { toast } from 'react-toastify'
import CustomeLoader from '../../../core/common/customeLoader/CustomeLoader'
import Loading from '../../../core/common/custom-loading/Loading'
import dayjs from "dayjs";
const BookingReconciliation = () => {
  const routes = all_routes;
  // const data = bookingReconciliationList;

  const [state, setState] = useState<any>([])
  const [loading, setLoading] = useState<any>([])
  const [selectedItemId, setSelectedItemId] = useState<any | null>(null);


  const getBookingReconciliation = async () => {
    try {
      setLoading(true)
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.LEAD_BOOKING_RECONCILIATION)
      console.log("booking reconsiliation data is here", response?.data)

      setState(response?.data)
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    getBookingReconciliation();
  }, [])

  const [selectedId, setSelectedId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState<any>('');
  const [verifyResponse, setVerifyResponse] = useState<any>(false);
  const [modalOpen, setModalOpen] = useState(false);
  // console.log("rsponse dfljsafmilal", verifyResponse)



  const verifyBooking = async (data: { verify: string; lost_reason?: string }) => {
    try {
      const payload = {
        lead_account_id: selectedId,
        verified: data.verify,
        lost_reason: data.lost_reason || '',
      };
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.VERIFY_LEADS_BOOKING, payload)

      // console.log("Verify booking response:adasdf", response);

      if (response?.data?.success === true) {
        setVerifyResponse(response?.data?.success)
        toast.success(response?.data?.message)
        setModalOpen(false)
        getBookingReconciliation()

      }


    } catch (error) {
      console.log("error", error);
    }
  }


const columns = [
  // {
  //   title: "Lead ID",
  //   dataIndex: "lead_account_id",
  //   key: "lead_account_id",
  //   render: (text: any) => text ?? "-",
  // },
  {
    title: "Lead Name",
    dataIndex: "lead_name",
    key: "lead_name",
    sorter: (a: any, b: any) => (a.lead_name || "").localeCompare(b.lead_name || ""),
    render: (text: string) => text ?? "-",
  },
{
  title: "Group Name",
  dataIndex: "group_name",
  key: "sales_owner",
  render: (text: string) => text ?? "-",
  sorter: (a: any, b: any) =>
    (a.sales_owner ?? "").localeCompare(b.sales_owner ?? ""),
},

  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (text: any) => (text ? `₹${text}` : "-"),
     sorter: (a: any, b: any) => (a.amount || 0) - (b.amount || 0),
  },
  {
    title: "Created Date",
    dataIndex: "created_date",
    key: "created_date",
    sorter: (a: any, b: any) =>
      dayjs(a.created_date, "DD/MM/YYYY").unix() -
      dayjs(b.created_date, "DD/MM/YYYY").unix(),
    render: (text: string) =>
      text ? dayjs(text, "DD/MM/YYYY").format("DD/MM/YYYY") : "-",
  },
  {
    title: "Closed Date",
    dataIndex: "closed_date",
    key: "closed_date",
    sorter: (a: any, b: any) =>
      dayjs(a.closed_date, "DD/MM/YYYY").unix() -
      dayjs(b.closed_date, "DD/MM/YYYY").unix(),
    render: (text: string) =>
      text ? dayjs(text, "DD/MM/YYYY").format("DD/MM/YYYY") : "-",
  },
// {
//   title: "Property Name",
//   dataIndex: "property_name",
//   key: "property_name",
//   render: (text: string) => text ?? "-",
//   sorter: (a: any, b: any) =>
//     (a.property_name ?? "").localeCompare(b.property_name ?? ""),
// },
// {
//   title: "Structure Type",
//   dataIndex: "structure_type",
//   key: "structure_type",
//   render: (text: string) => text ?? "-",
//   sorter: (a: any, b: any) =>
//     (a.structure_type ?? "").localeCompare(b.structure_type ?? ""),
// },

//   {
//     title: "No. of Beds",
//     dataIndex: "number_of_beds",
//     key: "number_of_beds",
//     render: (text: number) => text ?? "-",
//       sorter: (a: any, b: any) => (a.number_of_beds || 0) - (b.number_of_beds || 0),
//   },
  {
    title: "Locality",
    dataIndex: "locality",
    key: "locality",
    sorter: (a: any, b: any) => (a.locality || "").localeCompare(b.locality || ""),
    render: (text: string) => text ?? "-",
  },
  {
    title: "City",
    dataIndex: "city",
    key: "city",
    sorter: (a: any, b: any) => (a.city || "").localeCompare(b.city || ""),
    render: (text: string) => text ?? "-",
  },
  {
    title: "State",
    dataIndex: "state",
    key: "state",
    sorter: (a: any, b: any) => (a.state || "").localeCompare(b.state || ""),
    render: (text: string) => text ?? "-",
  },
// {
//   title: "Bank Name",
//   dataIndex: "bank_name",
//   key: "bank_name",
//   render: (text: string) => text ?? "-",
//   sorter: (a: any, b: any) => 
//     (a.bank_name ?? "").localeCompare(b.bank_name ?? ""),
// },

{
  title: "Transaction ID",
  dataIndex: "transaction_id",
  key: "transaction_id",
  render: (text: string) => text ?? "-",
  sorter: (a: any, b: any) =>
    (a.transaction_id ?? "").localeCompare(b.transaction_id ?? ""),
},

  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
    render: (text: string) => {
      const status = text?.toLowerCase();
      let textColor = "inherit";

      switch (status) {
        case "false booking":
          textColor = "red";
          break;
        case "pending":
          textColor = "goldenrod";
          break;
        case "ok":
          textColor = "green";
          break;
      }

      return (
        <span
          className="text-capitalize"
          style={{
            color: textColor,
            padding: "4px 6px",
            borderRadius: "6px",
            display: "inline-block",
            minWidth: "100px",
            textAlign: "center",
          }}
        >
          {text ?? "-"}
        </span>
      );
    },
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: (_: any, record: any) => {
      const status = record?.status?.toLowerCase();
      const isPending = status === "pending";
      const isDisabled = status === "ok" || status === "false booking";

      return (
        <div className="action-icon d-inline-flex">
          {/* View Details */}
          {/* <Link
            to="#"
            className="me-2 text-primary"
            data-bs-toggle="modal"
            data-bs-target="#view_modal"
            title="View Details"
            onClick={() => setSelectedItemId(record)}
          >
            <i className="ti ti-eye" />
          </Link> */}

          {/* Verified */}
          <Link
            to="#"
            className={`me-2 ${isDisabled ? "text-muted disabled-link" : "text-success"}`}
            title={isDisabled ? "Action disabled" : "Mark as Verified"}
            data-bs-toggle={isPending ? "modal" : undefined}
            data-bs-target={isPending ? "#verified_modal" : undefined}
            onClick={() => {
              if (isPending) {
                setSelectedId(record.lead_account_id);
                setVerifyResponse("");
              }
            }}
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          >
            <i className="ti ti-check" />
          </Link>

          {/* False Booking */}
          <Link
            to="#"
            className={`${isDisabled ? "text-muted disabled-link" : "text-danger"}`}
            title={isDisabled ? "Action disabled" : "Mark as False Booking"}
            onClick={() => {
              if (isPending) {
                setSelectedId(record.lead_account_id);
                setModalOpen(true);
              }
            }}
            style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
          >
            <i className="ti ti-alert-triangle" />
          </Link>
        </div>
      );
    },
  },
];


  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Booking Reconciliation </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                    Dashboard
                  </Link></li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Booking Reconciliation
                  </li>
                </ol>
              </nav>
            </div>

          </div>
          {/* /Breadcrumb */}
          {/* Leads List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Booking Reconciliation List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="me-3">
              <div className="input-icon-end position-relative">
                <PredefinedDateRanges/>
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div> */}


              </div>
            </div>
            {
              loading ? (
                <Loading />
              ) : (
                <div className="card-body p-0">
                  <Table dataSource={state} columns={columns} Selection={false} />
                </div>
              )
            }
          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <CrmsModal/> */}

      {/* verify modal  code  starting */}

      <div
        className="modal fade"
        id="verified_modal"
        tabIndex={-1}
        aria-labelledby="verifiedModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="verifiedModalLabel">
                Mark as Verified
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              Are you sure you want to mark this as verified?
            </div>
            <div className="modal-footer pe-2">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="modal"
              >
                <span className='me-2'>Cancel</span>
              </button>


              <button type="button" className="btn btn-confirm me-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  verifyBooking({
                    verify: "OK"
                  })
                }}>
                <span>Confirm</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* verify modal  code  end */}


      {/* false booking modal starting  */}


      {modalOpen && (
        <div className="modal-backdrop1" onClick={() => setModalOpen(false)}>
          <div
            className="modal-container1"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header1">
              <h2>Mark as False Booking</h2>
              <button className="close-button" onClick={() => setModalOpen(false)}>&times;</button>
            </div>

            <div className="modal-body1">
              <p>Are you sure you want to mark this booking as false?</p>
              <textarea
                className="comment-box1"
                placeholder="Add a comment..."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  if (e.target.value.trim()) setError("");
                }}
              />
              {error && <p className="error-text1">{error}</p>}
            </div>

            <div className="modal-footer1">
              <button className="btn-cancel" onClick={() => setModalOpen(false)}>Cancel</button>
              <button
                className="btn-confirm"
                disabled={!reason.trim()}
                onClick={() => {
                  if (!reason.trim()) {
                    setError("Please add a comment.");
                    return;
                  }
                  verifyBooking({ verify: "FALSE BOOKING", lost_reason: reason });
                  setReason('');
                  setModalOpen(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}






      {/* old code  */}
      {/* {modalOpen && (
        <div className="modal-backdrop" onClick={() => setModalOpen(false)}>
          <div
            className="modal-content-false"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h5 className="modal-title">False Booking</h5>
              <button
                className="btn-close"
                onClick={() => setModalOpen(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <div className="modal-body">
              <p className="modal-question">Are you sure you want to mark this booking as false?</p>
              <textarea
                className="modal-textarea"
                placeholder="Add a comment..."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  if (e.target.value.trim()) setError("");
                }}
              />
              {error && <p className="error">{error}</p>}
            </div>

            <div className="modal-footer">
              <button className="btn btn-cancel" onClick={() => setModalOpen(false)}>
                <span>Cancel</span>
              </button>
              <button
                className="btn btn-confirm"
                disabled={!reason.trim()}
                onClick={() => {
                  if (!reason.trim()) {
                    setError("Please add a comment.");
                    return;
                  }
                  verifyBooking({ verify: "FALSE BOOKING", lost_reason: reason });
                  setReason('');
                }}
              >
                <span>Confirm</span>
              </button>
            </div>
          </div>
        </div>
      )} */}
      {/* old code end  */}

      {/* false booking modal end */}



      {/* view open modal start  */}
      <div
        className="modal fade"
        id="view_modal"
        aria-labelledby="viewModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content rounded-4 shadow-sm">
            <div className="modal-header border-bottom-1 border-light">
              <h5 className="modal-title fw-bold fs-5 text-dark" id="viewModalLabel">
                Booking Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body px-4 py-3">
              {selectedItemId ? (
                <div className="details-grid">
                  {[
                    ["lead_account_id", selectedItemId.lead_account_id],
                    ["Lead Name", selectedItemId.lead_name],
                    ["Property Name", selectedItemId.property_name || "N/A"],
                    ["City", selectedItemId.city],
                    ["State", selectedItemId.state],
                    ["Locality", selectedItemId.locality],
                    ["Structure Type", selectedItemId.structure_type],
                    ["Beds", selectedItemId.number_of_beds],
                    ["Sales Owner", selectedItemId.sales_owner || "N/A"],
                    ["Product", selectedItemId.product || "N/A"],
                    ["Amount", selectedItemId.amount || "N/A"],
                    ["Transaction ID", selectedItemId.transaction_id || "N/A"],
                    ["Bank Name", selectedItemId.bank_name],
                    ["IFSC", selectedItemId.ifsc_code || "N/A"],
                    ["Created Date", selectedItemId.created_date],
                    ["Closed Date", selectedItemId.closed_date || "N/A"],
                  ].map(([label, value], i) => (
                    <div key={i} className="detail-item">
                      <span className="detail-label">{label}</span>
                      <span className="detail-value">{value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted fst-italic">
                  Select a record to see details
                </p>
              )}
            </div>
          </div>
        </div>
      </div>





      {/* view open modal end  */}

    </>

  )
}

export default BookingReconciliation;